/**
 * Adyen payment configuration
 * Re-exports configuration from main config for type safety and convenience
 */
import { config } from '@/config';
import { getAdyenLocale } from '@/helpers/adyen';
import { getLang } from '@/locale';

export const ADYEN_CONFIG = {
  ENVIRONMENT: config.env === 'production' || config.envName === 'stage' ? 'live' : 'test',
  CLIENT_KEY: config.adyen.clientKey,
  LOCALE: getAdyenLocale(getLang()),
  CURRENCY: config.adyen.currency,
  COUNTRY_CODE: config.adyen.countryCode,
} as const;

export const ADYEN_CARD_CONFIG = {
  hasHolderName: true,
  holderNameRequired: true,
  name: 'Credit or debit card',
  amount: { value: 0, currency: ADYEN_CONFIG.CURRENCY },
  challengeWindowSize: '05',
} as const;
